// Webpack Imports
import * as bootstrap from "bootstrap";
import jquery, * as $ from "jquery";

(function () {
  "use strict";

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})();

// sticky header
$(function () {
  let $window = $(window);
  let lastScrollTop = 0;
  let $header = $("#header");
  let headerHeight = $header.outerHeight();

  $window.scroll(function () {
    let windowTop = $window.scrollTop();

    if (windowTop >= headerHeight) {
      $header.addClass("sticky-hide");
    } else {
      $header.removeClass("sticky-hide");
      $header.removeClass("sticky");
    }

    if ($header.hasClass("sticky-hide")) {
      if (windowTop < lastScrollTop) {
        $header.addClass("sticky");
      } else {
        $header.removeClass("sticky");
      }
    }
    lastScrollTop = windowTop;
  });
});

// top header bar
$(function () {
  if (localStorage.getItem("header-top") == "false") {
    $(".header-top").addClass("header-none");
  }
  $(".remove-top-header").click(function () {
    console.log("clicked");
    $(".header-top").addClass("header-none");
    localStorage.setItem("header-top", false);
  });
});

// tabs horizontal scroll
var box = $(".vc_tta-tabs-list"), x;
$(".arrow").click(function() {
  if ($(this).hasClass("arrow-right")) {
    x = ((box.width() / 2)) + box.scrollLeft();
    box.animate({
      scrollLeft: x,
    })
  } else {
    x = ((box.width() / 2)) - box.scrollLeft();
    box.animate({
      scrollLeft: -x,
    })
  }
})